import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AppContextService } from 'src/app/data/services/app-context.service';
import { ErrorDialogService } from './error-dialog.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private errorDialogService: ErrorDialogService,
    private zone: NgZone,
    private router: Router,
    private appContext: AppContextService
  ) {}

  private httpErrorActions: Record<number, (error: HttpErrorResponse, request?: any) => void> = {
    401: (error) => {
      // handled by AuthInterceptor
      console.log('401 error handler');
    },
    // 403: (error) => this.redirect('/forbidden'),
    // 404: (error) => this.redirect('/not-found'),
  };

  handleError(error: any) {
    let httpError: HttpErrorResponse | null = null;
    let request: any;

    // Desestructurar si viene en formato [error, request]
    if (Array.isArray(error)) {
      [httpError, request] = error;
    } else if (error instanceof HttpErrorResponse) {
      httpError = error;
    }

    if (httpError) {
      // Comprobación de conexión a Internet
      if (!navigator.onLine) {
        this.zone.run(() => {
          this.errorDialogService.openNetworkDialog(
            'Parece que no tienes conexión a Internet. Revisa tu red e inténtalo de nuevo.',
            httpError!.status
          );
        });
        return;
      }

      if (httpError!.status === 401) {
        console.log('401 error handler');
        return;
      }

      const action = this.httpErrorActions[httpError!.status] || 
                    ((err: HttpErrorResponse, req?: any) => this.defaultHttpError(err, req));

      this.zone.run(() => action.call(this, httpError!, request));
      return;
    }

    console.error('Error from global error handler', error);
  }

  private showDialog(message: string, error: HttpErrorResponse, request?: any) {
    if (this.appContext.isMoodle) {
      this.router.navigate(['/moodle-error']);
    } else {
      this.errorDialogService.openDialog(
        message,
        error.status,
        request
      );
    }
  }

  private redirect(route: string) {
    this.router.navigate([route]);
  }

  private defaultHttpError(error: HttpErrorResponse, request?: any) {
    this.showDialog(error.message || 'Undefined client error', error, request);
  }
}
